import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import PDFIcon from "../../assets/pdf.svg?react";
import { AdjuntosContext } from "../../context/AdjuntosContext";
import { ProyectosContext } from "../../context/ProyectosContext";
import { S3_ENDPOINT } from "../../utils";

const AdjuntoEntrada = ({ adjunto }) => {

  const params = useParams();
  const { proyecto } = useContext(ProyectosContext);
  // Comment modals render outside the obra routes, where useParams has no
  // idProyecto: fall back to the obra in context.
  const idProyecto = params.idProyecto || proyecto?.idProyecto;
  const { setSingleAdjunto, downloadAdjunto } = useContext(AdjuntosContext);

  if (["pdf", "PDF"].includes(adjunto.tipo)) {
    return (
      <div
        onClick={() => setSingleAdjunto(adjunto, { disableComments: true })}
        className="row py-2 mb-2 mx-0 align-items-center bg-light br-10 border"
      >
        <div className="col-3">
          <PDFIcon />
        </div>
        <div className="col-9" style={{ minWidth: 0 }}>
          <p
            className="bold text-dark mb-1"
            style={{ overflowWrap: "anywhere", wordBreak: "break-word" }}
          >
            {adjunto.nombre}.{adjunto.tipo}
          </p>
          {/*
          <Link
            to={`/obra/${idProyecto}/supervision/${adjunto.AdjuntoFolders[0]?.idFolder}`}
            className="small btn btn-sm px-0 d-inline-block text-capitalize text-dark text-decoration-underline"
            onClick={(e) => e.stopPropagation()}
          >
            <i className="fa fa-eye me-2" />
            {adjunto.AdjuntoFolders[0]?.Folder?.nombre || "Folder"}
          </Link>
          */}
        </div>
      </div>
    );
  }
  
  if (["jpg", "png", "jpeg", "gif", "webp"].includes(adjunto.tipo)) {
    const source =
      adjunto.src === null
        ? `${S3_ENDPOINT}/files/proyectos/${adjunto.idAdjunto}.${adjunto.tipo}`
        : adjunto.src;
    return (
      <img
        src={source}
        alt={adjunto.nombre}
        onClick={() => setSingleAdjunto(adjunto, { disableComments: true })}
        className="adjunto-mensaje d-inline-block mb-2 me-2"
      />
    );
  }

  if (String(adjunto.tipo).includes("video")) {
    return (
      <video className="mw-100 w-100 d-block m-auto" controls playsInline>
        <source src={adjunto.src} />
      </video>
    );
  }

  if (String(adjunto.tipo).includes("audio")) {
    return (
      <audio className="mw-100 w-100 d-block m-auto mb-3" controls playsInline>
        <source src={adjunto.src} />
      </audio>
    );
  }

  const filename = `${adjunto.nombre}.${adjunto.tipo}`;

  const handleDownload = (e) => {
    e.stopPropagation();
    downloadAdjunto(idProyecto, adjunto);
  };

  return (
    <div className="row py-2 mb-2 mx-0 align-items-center bg-light br-10 border">
      <div className="col-2 d-flex align-items-center justify-content-center">
        <div
          style={{
            width: 48,
            height: 48,
            borderRadius: "50%",
            background: "#6c757d",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <i className="fa fa-file text-white" style={{ fontSize: 22 }} />
        </div>
      </div>
      <div className="col-8 ps-0" style={{ minWidth: 0 }}>
        <p className="bold text-dark mb-0 text-truncate" style={{ fontSize: 13 }}>
          {filename}
        </p>
      </div>
      <div className="col-2 d-flex align-items-center justify-content-end pe-2">
        <button
          type="button"
          className="btn btn-sm btn-primary p-1"
          onClick={handleDownload}
          style={{ lineHeight: 1 }}
        >
          <i className="fa fa-download text-white" style={{ fontSize: 13 }} />
        </button>
      </div>
    </div>
  );
};

export default AdjuntoEntrada;
